<template>
    <a-modal
        :keyboard="false"
        :maskClosable="false"
        centered
        :visible="visible"
        title="导入价格"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="420"
        :after-close="after_close"
        :ok-button-props="{ props: { disabled: submitting } }"
        :cancel-button-props="{ props: { disabled: submitting } }"
    >
        <a-alert
            message="导入须知"
            description="Excel表头必须包含【注册号】【价格】(【备注【可选)"
            type="info"
            show-icon
            style="margin-bottom:24px"
        />

        <a-form-model :model="form" ref="supplier_import_price" :rules="rules">
            <a-form-model-item label="供应商">
                <a-input :value="record ? record.contact_name : null" disabled />
            </a-form-model-item>

            <a-form-model-item label="批量更新的Excel">
                <a-upload
                    name="file"
                    :action="action"
                    :withCredentials="true"
                    @change="(info) => on_upload_change(info, 'file')"
                    accept=".xlsx"
                    :fileList="fileList"
                >
                    <div class="upload">
                        <a-button> <a-icon type="upload" /> 选择Excel文件 </a-button>
                    </div>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item label="覆盖现有数据" extra="覆盖并删除同商标号下的其他供应商数据">
                <a-switch v-model="form.is_cover"></a-switch>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    import env from "../../../../env";

    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
        },
        data() {
            return {
                action: env.base_url + "service/upload",
                submitting: false,
                uploading: false,
                fileList: [],
                form: {
                    file: null,
                    is_cover: false,
                },
                rules: {
                    file: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请选择Excel文件",
                        },
                    ],
                },
            };
        },

        watch: {
            visible(v) {
                if (v && this.record) {
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["supplier_import_price"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.form.supplier_id = this.record.id;
                        this.$http
                            .post("/trademark/supplier/import_price", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({
                                        title: "失败",
                                        content: res.message,
                                        centered: true,
                                    });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            on_upload_change(info, field) {
                this.fileList = info.fileList.slice(-1);

                if (info.file.status === "uploading") {
                    this.uploading = true;
                    return;
                }
                if (info.file.status === "done") {
                    this.uploading = false;
                    if (info.file.response.success) {
                        this.form[field] = info.file.response.data.url;
                    } else {
                        this.$error({
                            title: "失败",
                            centered: true,
                            content: info.file.response.message,
                        });
                    }
                } else if (info.file.status === "error") {
                    this.$message.error(`${info.file.name} 上传失败.`);
                }
            },
            beforeUpload(e) {
                this.form.file = e;
                return false;
            },
            after_close() {
                this.$refs["supplier_import_price"].resetFields();

                // this.form = JSON.parse(JSON.stringify(init_form));

                this.fileList = [];
            },
        },
    };
</script>
